var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"core_tech_wrap"},[_vm._m(0),_c('CarouseCard',{attrs:{"items":_vm.coreTechData,"interval":9000}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title_container"},[_c('div',{staticClass:"title_box"},[_c('div',{staticClass:"title_1"},[_vm._v("CORE TECHNOLOGIES")]),_c('div',{staticClass:"title_2"},[_vm._v("核心技术")]),_c('div',{staticClass:"title_3"})])])
}]

export { render, staticRenderFns }